unit Essentials.Web.RequiredFields.Editor;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WebForm.Core, Data.DB, WEBLib.DB,
  WEBLib.Lists, WEBLib.Grids, WEBLib.DBCtrls, WEBLib.Controls, WEBLib.Dialogs,
  Vcl.StdCtrls, WEBLib.StdCtrls, XData.Web.Dataset, JS, Grid.Plugins, Types, WebLib.ExtCtrls, Web,
  WEBLib.WebCtrls;

type
  TEssentialsRequiredFieldEditor = class(TCoreWebForm)
    lbPaginationInfo: TLabel;
    AddButton: TButton;
    cbPageSize: TComboBox;
    ConfirmationMsg: TMessageDlg;
    EssentialsTable: TDBTableControl;
    lcPaginator: TListControl;
    DataSource: TDataSource;
    procedure AddButtonClick(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
    procedure DataSourceDataChange(Sender: TObject; Field: TField);
    procedure EssentialsTableGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure WebFormCreate(Sender: TObject);
  private
    { Private declarations }
    FIdField: string;
    FGridPlugin: TGridPlugin;
    procedure RefreshControls(aShow: Boolean);
    [Async]
    procedure Save; async;
    [Async]
    procedure ToggleActiveRecord(ARecordId: string); async;
    [Async]
    procedure AddRecord; async;
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
    procedure DeactivateOtherActiveForEntityField(const AEntityClassName, AFieldName, AExcludeId: string);
    function FindOtherActiveRule(const AEntityClassName, AFieldName, AExcludeId: string): Boolean;
  protected
    { Public declarations }
    procedure SetDataSet(aDataSet:TXdataWebDataset);
  protected procedure LoadDFMValues; override; end;

var
  EssentialsRequiredFieldEditor: TEssentialsRequiredFieldEditor;

implementation

uses Essentials.Web.Shared, SMX.Web.Layout.Utils, SMX.webcore.Types,
Essentials.Web.RequiredFields.EditValueForm, StrUtils, Essentials.Web.Manager;

{$R *.dfm}

procedure TEssentialsRequiredFieldEditor.AddButtonClick(Sender: TObject);
begin
  inherited;
  AddRecord;
end;

procedure TEssentialsRequiredFieldEditor.AddRecord;
var
  AForm: TRequiredFieldsEditValue;
  lEntityClassName, lFieldName, lMsg: string;
  lDeactivatedFound, lActiveFound: Boolean;
begin
  AForm := TRequiredFieldsEditValue.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    Await(TRequiredFieldsEditValue, AForm.Load());
    DataSource.DataSet.Insert;
    AForm.SetDataSources(DataSource.DataSet);
    AForm.LoadEntityList;
    AForm.EditMode := Add;

    if Await(TModalResult, AForm.Execute) = mrOK then
    begin
      lEntityClassName := AForm.EntitySelector.Value;
      lFieldName := AForm.FieldSelector.Value;

      if DataSource.DataSet.State in [dsInsert, dsEdit] then
        DataSource.DataSet.Cancel;

      lDeactivatedFound := False;
      lActiveFound := False;
      DataSource.DataSet.First;
      while not DataSource.DataSet.Eof do
      begin
        if SameText(DataSource.DataSet.FieldByName('EntityClassName').AsString, lEntityClassName) and
           SameText(DataSource.DataSet.FieldByName('FieldName').AsString, lFieldName) then
        begin
          if DataSource.DataSet.FieldByName('IsActive').AsBoolean then
            lActiveFound := True
          else
            lDeactivatedFound := True;
        end;
        DataSource.DataSet.Next;
      end;

      if lActiveFound then
      begin
        ConfirmationMsg.Title := 'Already Exists';
        lMsg := Format('An active required field rule already exists for %s.%s.', [lEntityClassName, lFieldName]);
        Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtWarning, [mbOK]));
      end
      else if lDeactivatedFound then
      begin
        lMsg := Format('A deactivated required field rule for %s.%s already exists. Would you like to reactivate it instead?', [lEntityClassName, lFieldName]);
        ConfirmationMsg.Title := 'Reactivate Existing';
        if Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtConfirmation, [mbYes, mbNo])) = mrYes then
        begin
          DataSource.DataSet.First;
          while not DataSource.DataSet.Eof do
          begin
            if SameText(DataSource.DataSet.FieldByName('EntityClassName').AsString, lEntityClassName) and
               SameText(DataSource.DataSet.FieldByName('FieldName').AsString, lFieldName) and
               (not DataSource.DataSet.FieldByName('IsActive').AsBoolean) then
            begin
              DataSource.DataSet.Edit;
              DataSource.DataSet.FieldByName('IsActive').AsBoolean := True;
              DataSource.DataSet.Post;
              Break;
            end;
            DataSource.DataSet.Next;
          end;
          Await(Save);
          EssentialsManager.RequiredFieldsManager.UpdateCacheEntry(lEntityClassName, lFieldName, True);
        end;
      end
      else
      begin
        DataSource.DataSet.Insert;
        DataSource.DataSet.FieldByName('EntityClassName').AsString := lEntityClassName;
        DataSource.DataSet.FieldByName('FieldName').AsString := lFieldName;
        DataSource.DataSet.Post;
        Await(Save);
        EssentialsManager.RequiredFieldsManager.UpdateCacheEntry(lEntityClassName, lFieldName, True);
      end;
    end
    else if DataSource.DataSet.State in [dsInsert, dsEdit] then
      DataSource.DataSet.Cancel;
  finally
    FreeAndNil(AForm);
  end;
end;

procedure TEssentialsRequiredFieldEditor.DeactivateOtherActiveForEntityField(const AEntityClassName,
  AFieldName, AExcludeId: string);
begin
  DataSource.DataSet.DisableControls;
  try
    DataSource.DataSet.First;
    while not DataSource.DataSet.Eof do
    begin
      if (DataSource.DataSet.FieldByName('Id').AsString <> AExcludeId) and
         SameText(DataSource.DataSet.FieldByName('EntityClassName').AsString, AEntityClassName) and
         SameText(DataSource.DataSet.FieldByName('FieldName').AsString, AFieldName) and
         DataSource.DataSet.FieldByName('IsActive').AsBoolean then
      begin
        DataSource.DataSet.Edit;
        DataSource.DataSet.FieldByName('IsActive').AsBoolean := False;
        DataSource.DataSet.Post;
      end;
      DataSource.DataSet.Next;
    end;
  finally
    DataSource.DataSet.EnableControls;
  end;
end;

function TEssentialsRequiredFieldEditor.FindOtherActiveRule(const AEntityClassName,
  AFieldName, AExcludeId: string): Boolean;
begin
  Result := False;
  DataSource.DataSet.DisableControls;
  try
    DataSource.DataSet.First;
    while not DataSource.DataSet.Eof do
    begin
      if (DataSource.DataSet.FieldByName('Id').AsString <> AExcludeId) and
         SameText(DataSource.DataSet.FieldByName('EntityClassName').AsString, AEntityClassName) and
         SameText(DataSource.DataSet.FieldByName('FieldName').AsString, AFieldName) and
         DataSource.DataSet.FieldByName('IsActive').AsBoolean then
        Exit(True);
      DataSource.DataSet.Next;
    end;
  finally
    DataSource.DataSet.EnableControls;
  end;
end;

procedure TEssentialsRequiredFieldEditor.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
  procedure ToggleActiveClick(Sender: TObject);
  begin
    ToggleActiveRecord(ARecordId);
  end;

var
  Span: THTMLSpan;
  lIsActive: Boolean;
begin
  lIsActive := DataSource.DataSet.FieldByName('IsActive').AsBoolean;
  if lIsActive then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-ban', 'Deactivate');
    Span.OnClick := @ToggleActiveClick;
  end
  else
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-check-circle', 'Reactivate');
    Span.OnClick := @ToggleActiveClick;
  end;
end;

procedure TEssentialsRequiredFieldEditor.cbPageSizeChange(Sender: TObject);
begin
  inherited;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TEssentialsRequiredFieldEditor.DataSourceDataChange(Sender: TObject;
  Field: TField);
begin
  inherited;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

procedure TEssentialsRequiredFieldEditor.ToggleActiveRecord(ARecordId: string);
var
  foundRecord: Boolean;
  lIsActive: Boolean;
  lName, lMsg, lEntityClassName, lFieldName: string;
begin
  foundRecord := DataSource.Dataset.Locate(FIdField, ARecordId, []);

  if foundRecord then
  begin
    lIsActive := DataSource.DataSet.FieldByName('IsActive').AsBoolean;
    lEntityClassName := DataSource.DataSet.FieldByName('EntityClassName').AsString;
    lFieldName := DataSource.DataSet.FieldByName('FieldName').AsString;
    lName := lFieldName;

    if lIsActive then
    begin
      ConfirmationMsg.Title := 'Deactivate';
      lMsg := Format('Are you sure you want to deactivate the required field rule for %s? This field will no longer be required.', [QuotedStr(lName)]);
    end
    else
    begin
      if FindOtherActiveRule(lEntityClassName, lFieldName, ARecordId) then
      begin
        ConfirmationMsg.Title := 'Already Exists';
        lMsg := Format('An active required field rule already exists for %s.%s. Deactivate it before reactivating this one.', [lEntityClassName, lFieldName]);
        Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtWarning, [mbOK]));
        Exit;
      end;

      ConfirmationMsg.Title := 'Reactivate';
      lMsg := Format('Are you sure you want to reactivate the required field rule for %s?', [QuotedStr(lName)]);
    end;

    if Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtConfirmation, [mbYes, mbNo])) = mrYes then
    begin
      if not lIsActive then
        DeactivateOtherActiveForEntityField(lEntityClassName, lFieldName, ARecordId);

      if not DataSource.DataSet.Locate(FIdField, ARecordId, []) then
        Exit;

      DataSource.DataSet.Edit;
      DataSource.DataSet.FieldByName('IsActive').AsBoolean := not lIsActive;
      DataSource.DataSet.Post;
      Await(Save);
      EssentialsManager.RequiredFieldsManager.UpdateCacheEntry(lEntityClassName, lFieldName, not lIsActive);
    end;
  end;
end;

procedure TEssentialsRequiredFieldEditor.EssentialsTableGetCellChildren(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: string;
begin
  if ARow = 0 then
    Exit;

  if EssentialsTable.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := DataSource.DataSet.FieldByName(FIdField).AsString;

    if RecordId <> '' then
      AddRowActions(RecordId, AElement.Element)
    else
      AElement.Element.textContent := 'Loading...';
  end;
end;

procedure TEssentialsRequiredFieldEditor.RefreshControls(aShow: Boolean);
begin
  lcPaginator.Visible := aShow;
  lbPaginationInfo.Visible := aShow;
  cbPageSize.Visible := aShow;
  SetHtmlElementVisible('essentials.requiredfields.PageSizeRow', aShow);
end;

procedure TEssentialsRequiredFieldEditor.Save;
begin
  Await(Boolean, EssentialsManager.RequiredFieldsManager.SaveChanges);
end;

procedure TEssentialsRequiredFieldEditor.SetDataSet(aDataSet: TXdataWebDataset);
begin
  DataSource.DataSet := aDataSet;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

procedure TEssentialsRequiredFieldEditor.WebFormCreate(Sender: TObject);
begin
  inherited;
  FIdField := 'Id';
  SetDataSet(EssentialsManager.RequiredFieldsManager.RequiredFieldsDataset);
  FGridPlugin := TGridPlugin.Create(EssentialsTable, EssentialsManager.RequiredFieldsManager.RequiredFieldsDataset, lcPaginator, lbPaginationInfo,
      TSortPair.Create(1, sdAsc));
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  RefreshControls(False);
end;

procedure TEssentialsRequiredFieldEditor.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('essentials.requiredfields.PageInfo');
  AddButton := TButton.Create('essentials.requiredfields.add.button');
  cbPageSize := TComboBox.Create('essentials.requiredfields.PageSizeSelect');
  ConfirmationMsg := TMessageDlg.Create('ConfirmationMsg');
  EssentialsTable := TDBTableControl.Create('esssentials.requiredfields.table');
  lcPaginator := TListControl.Create('essentials.requiredfields.Pagination');
  DataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  AddButton.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  ConfirmationMsg.BeforeLoadDFMValues;
  EssentialsTable.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 185;
    lbPaginationInfo.Top := 32;
    lbPaginationInfo.Width := 112;
    lbPaginationInfo.Height := 15;
    lbPaginationInfo.Caption := 'No records to display';
    lbPaginationInfo.ElementFont := efCSS;
    lbPaginationInfo.ElementPosition := epIgnore;
    lbPaginationInfo.HeightStyle := ssAuto;
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthStyle := ssAuto;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    AddButton.SetParentComponent(Self);
    AddButton.Name := 'AddButton';
    AddButton.Left := 72;
    AddButton.Top := 296;
    AddButton.Width := 96;
    AddButton.Height := 25;
    AddButton.Caption := 'Add';
    AddButton.ChildOrder := 7;
    AddButton.ElementClassName := 'btn btn-light';
    AddButton.ElementFont := efCSS;
    AddButton.ElementPosition := epIgnore;
    AddButton.HeightStyle := ssAuto;
    AddButton.HeightPercent := 100.000000000000000000;
    AddButton.WidthStyle := ssAuto;
    AddButton.WidthPercent := 100.000000000000000000;
    SetEvent(AddButton, Self, 'OnClick', 'AddButtonClick');
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 33;
    cbPageSize.Top := 29;
    cbPageSize.Width := 81;
    cbPageSize.Height := 23;
    cbPageSize.ElementClassName := 'form-select';
    cbPageSize.ElementFont := efCSS;
    cbPageSize.ElementPosition := epIgnore;
    cbPageSize.HeightStyle := ssAuto;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.Text := '10';
    cbPageSize.WidthStyle := ssAuto;
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    ConfirmationMsg.SetParentComponent(Self);
    ConfirmationMsg.Name := 'ConfirmationMsg';
    ConfirmationMsg.Left := 33;
    ConfirmationMsg.Top := 252;
    ConfirmationMsg.Width := 24;
    ConfirmationMsg.Height := 24;
    ConfirmationMsg.ElementClassName := 'PopUpForm';
    ConfirmationMsg.Buttons := [];
    ConfirmationMsg.Opacity := 0.200000000000000000;
    ConfirmationMsg.Title := 'Confirm';
    EssentialsTable.SetParentComponent(Self);
    EssentialsTable.Name := 'EssentialsTable';
    EssentialsTable.Left := 72;
    EssentialsTable.Top := 83;
    EssentialsTable.Width := 505;
    EssentialsTable.Height := 193;
    EssentialsTable.HeightStyle := ssAuto;
    EssentialsTable.WidthStyle := ssAuto;
    EssentialsTable.BorderColor := clSilver;
    EssentialsTable.ChildOrder := 3;
    EssentialsTable.ElementFont := efCSS;
    EssentialsTable.ElementHeaderClassName := 'thead-light';
    EssentialsTable.ElementPosition := epIgnore;
    EssentialsTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    EssentialsTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Footer.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Footer.DropDownElementClassName := 'form-control';
    EssentialsTable.Footer.InputElementClassName := 'form-control';
    EssentialsTable.Footer.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Footer.LinkElementClassName := 'link-secondary';
    EssentialsTable.Footer.ListElementClassName := 'pagination';
    EssentialsTable.Footer.ListItemElementClassName := 'page-item';
    EssentialsTable.Footer.ListLinkElementClassName := 'page-link';
    EssentialsTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Header.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Header.DropDownElementClassName := 'form-control';
    EssentialsTable.Header.InputElementClassName := 'form-control';
    EssentialsTable.Header.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Header.LinkElementClassName := 'link-secondary';
    EssentialsTable.Header.ListElementClassName := 'pagination';
    EssentialsTable.Header.ListItemElementClassName := 'page-item';
    EssentialsTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(EssentialsTable, Self, 'OnGetCellChildren', 'EssentialsTableGetCellChildren');
    EssentialsTable.Columns.Clear;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'EntityClassName';
      Title := 'Entity';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'FieldName';
      Title := 'Field';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'IsActive';
      DataType := cdCheck;
      Title := 'Active';
    end;
    with EssentialsTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    EssentialsTable.DataSource := DataSource;
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 153;
    lcPaginator.Top := 354;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightStyle := ssAuto;
    lcPaginator.WidthStyle := ssAuto;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.ChildOrder := 3;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementFont := efCSS;
    lcPaginator.ElementPosition := epIgnore;
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Items.Clear;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginator.Style := lsPagination;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    SetEvent(DataSource, Self, 'OnDataChange', 'DataSourceDataChange');
    DataSource.Left := 528;
    DataSource.Top := 288;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    AddButton.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    ConfirmationMsg.AfterLoadDFMValues;
    EssentialsTable.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
  end;
end;

end.
